import { TypeStatus } from '@/lib/api/playbackService';
import { TypeKeyValuePair } from '@/core/generated-types';

export function getCourseStatusDisplayText(
  courseStatus: TypeStatus,
  statusDisplayCopy: TypeKeyValuePair[],
) {
  const courseStatusDisplayCopyIdx = statusDisplayCopy.findIndex(
    (statusMapping) => statusMapping.fields.title === courseStatus,
  );

  if (courseStatusDisplayCopyIdx !== -1) {
    return statusDisplayCopy[courseStatusDisplayCopyIdx].fields.value;
  }

  return courseStatus;
}
